import {
	Column,
	ICommonTableOneProps,
	StyledTableCell,
} from './CommonTableStyles';

import styles from './CommonTable.module.scss';

interface ITableRowProps {
	isItemSelected: boolean;
	rowHoverData: any;
	rowData: any;
	tableProps: ICommonTableOneProps;
}
const TableRowComponent = (props: ITableRowProps) => {
	const { isItemSelected, rowData, tableProps, rowHoverData } = props;
	const { columns, rowKey = 'id', rowHoverEnabled = false } = tableProps;
	return (
		columns &&
		columns.map((v: Column) => {
			const columnCellRender = v.render ? v.render(rowData) : rowData[v.id];
			const renderCell =
				isItemSelected && v.isCellEditable
					? v.renderEditCell(rowData)
					: columnCellRender;
			const displayCell =
				rowHoverEnabled &&
				rowHoverData === rowData[rowKey] &&
				v.isCellHoverEditable &&
				v?.renderHoverEditCell
					? v.renderHoverEditCell(rowData)
					: renderCell;
			return v.isHidden ? null : (
				<StyledTableCell
					align="left"
					key={`enhanced-table-cell-${v.id}${rowData[v.id]}`}
					className={`${styles['table-column-cell']} ${
						v.cellClassName ? v.cellClassName : ''
					}`}
					sx={{
						height: 50,
					}}
				>
					{displayCell}
				</StyledTableCell>
			);
		})
	);
};

export default TableRowComponent;
